import request from '../utils/request';
import { REST_SERVICE } from '../config';

// 抵押合同信息查询
export const getQueryDyhtxx = (data) =>
  request({
    url: REST_SERVICE.mortgageContract.getQueryDyhtxx,
    method: 'post',
    data
  });
